import SageButton from "kit/SageButton";
import React from "react";
import { Alert, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import authenticationStatusSelector from "selectors/authenticationStatus";
import createAnimationSelectedAnimationTypeSelector from "selectors/createAnimationSelectedAnimationType";
import createAnimationUploadVideoProgressSelector from "selectors/createAnimationUploadVideoProgress";
import createAnimationUploadVideoStatusSelector from "selectors/createAnimationUploadVideoStatus";
import AuthDialog from "ui/welcome/AuthDialog";
import AnimationSection from "./AnimationSection";
import styles from "./UploadVideoSection.module.scss";

const UploadVideoSection: React.FC = () => {
    const dispatch = useDispatch();

    const fileRef = React.useRef<HTMLInputElement>();
    const animationType = useSelector(
        createAnimationSelectedAnimationTypeSelector
    );
    const uploadProgress = useSelector(
        createAnimationUploadVideoProgressSelector
    );
    const authenticationStatus = useSelector(authenticationStatusSelector);
    const [isFrontFacing] = React.useState(false);
    const uploadStatus = useSelector(createAnimationUploadVideoStatusSelector);
    // const isFrontFacingChanged = React.useCallback(() => {
    // setIsFrontFacing(!isFrontFacing);
    // }, [isFrontFacing]);
    const [authDialogShown, setAuthDialogShown] = React.useState(false);

    const formSubmit = React.useCallback(
        (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            if (uploadStatus === "finished") {
                dispatch({
                    tab: 2,
                    type: "com.sage.actions.createAnimation.ISetTab",
                } as sage.actions.createAnimation.ISetTab);
                return;
            }

            if (!fileRef.current || !fileRef.current.files) {
                // TODO (dito) Ensure the user has selected a file
                return;
            }
            const file = fileRef.current.files[0];

            if (authenticationStatus !== "authenticated") {
                setAuthDialogShown(true);
                return;
            }

            dispatch({
                type: "com.sage.actions.createAnimation.IUploadVideoFile",
                isFrontFacingCamera: isFrontFacing,
                animationType: animationType,
                file: file,
            } as sage.actions.createAnimation.IUploadVideoFile);
        },
        [
            dispatch,
            animationType,
            isFrontFacing,
            setAuthDialogShown,
            authenticationStatus,
            fileRef,
            uploadStatus,
        ]
    );

    const uploadStatusText = React.useMemo(() => {
        if (uploadStatus === "uploading") {
            const uploadNumber = Math.round(uploadProgress * 100);
            return <p>Uploading {uploadNumber}%</p>;
        }
        return null;
    }, [uploadStatus, uploadProgress]);

    return (
        <>
            <AuthDialog
                description="Uploading a file requires you to login or create an account. This way, you can access your animation and video files later"
                show={authDialogShown}
                handleClose={() => setAuthDialogShown(false)}
            />
            <AnimationSection
                title="Upload Video File"
                description="Please upload the video file that acts out the animation that you want to turn into an animation."
            >
                <Form onSubmit={formSubmit}>
                    <Form.Group>
                        <Form.File
                            ref={fileRef as any}
                            id="uploadfile"
                            label="Video that you would like turned into an animation"
                        />
                        <Form.Text>
                            To get this to work the best, try to keep your
                            camera still and the subject matter within frame at
                            all time.
                        </Form.Text>
                    </Form.Group>
                    {/* <Form.Group>
                        <Form.Check
                            onClick={isFrontFacingChanged}
                            type="checkbox"
                            label="Is Front Facing Capera"
                        />
                        <Form.Text>
                            If you took the image using your phone front facing
                            camera or a camera on a desktop or laptop, check
                            this
                        </Form.Text>
                    </Form.Group> */}
                    <SageButton
                        type="submit"
                        loading={
                            uploadStatus !== "none" &&
                            uploadStatus !== "error" &&
                            uploadStatus !== "finished"
                        }
                        text={
                            uploadStatus === "finished"
                                ? "Uploaded, Go to Next"
                                : "Upload"
                        }
                    />
                    {uploadStatusText}
                </Form>
                {uploadStatus === "error" && (
                    <Alert variant="danger" className={styles.errorAlert}>
                        An error occurred uploading your file. Pleae try again.
                    </Alert>
                )}
            </AnimationSection>
        </>
    );
};

export default UploadVideoSection;
